import type { RetriggerInvoiceCheckRunResponse } from './types';

import { ENDPOINT } from '~/constants/endpoints';

import type { UUID } from '~/types/common';

import { vestigasApi } from '~/services/kyClient';

import { zodCheckRunSchema } from '../useQueryInvoiceDetail/validations';

/**
 * Starts a manual check run for an invoice and resolves with the run once the
 * API has evaluated it. A run that failed resolves as data with
 * `status: 'failed'`; only a refused request rejects.
 *
 * @param invoiceId - Invoice identifier.
 * @returns The evaluated check run.
 * @see https://app.dev.vestigas.com/redoc#tag/Invoices/operation/retrigger_check_run_invoices__invoice_id__check_run_post
 */
export async function retriggerInvoiceCheckRun(invoiceId: UUID) {
  return vestigasApi
    .post(ENDPOINT.INVOICE.RETRIGGER_CHECK_RUN(invoiceId), {
      validate: {
        isResponseSensitive: true,
        response: zodCheckRunSchema,
      },
    })
    .json<RetriggerInvoiceCheckRunResponse>();
}
